// Set of top level News categories
const NEWS_TERM_NEWS_TYPE = "News Types";
const NEWS_TERM_NEWS_INDUSTRY = "By Industry";
const NEWS_TERM_NEWS_YEAR = "By Year";

const NEWS_CONTENT_TYPE_ID = "news";
const NEWS_TERM_CONTENT_TYPE_ID = "newsTerm";

const NEWS_PATHNAME = "news";
const NEWS_SEARCH_PLACEHOLDER = "news.search-text";
const NEWS_NO_RESULTS_TEXT = "news.no-results-text";
const NEWS_RESET_FILTERS_TEXT = "news.clear-filters";
const NEWS_NO_RESULTS_ERROR = "news.validation-no-results";

const slugTermMapping = {
    "/company/in-the-news/": "In The News",
    "/company/press-room/": "Press Release",
};
const NEWS_PAGE_SIZE = 9;
const NEWS_BUTTON_TEXT = "news.read-more";
const NEWS_BUTTON_TYPE = "news.green-link";

/**
 * Mapping of category types against query params for News
 */
const newsCategoryFieldMapping = {
    [NEWS_TERM_NEWS_YEAR]: "dateTime",
    [NEWS_TERM_NEWS_INDUSTRY]: "industry",
    [NEWS_TERM_NEWS_TYPE]: "newsType",
};

export {
    NEWS_TERM_NEWS_TYPE,
    NEWS_TERM_NEWS_INDUSTRY,
    NEWS_CONTENT_TYPE_ID,
    NEWS_TERM_CONTENT_TYPE_ID,
    newsCategoryFieldMapping,
    NEWS_TERM_NEWS_YEAR,
    NEWS_NO_RESULTS_TEXT,
    NEWS_RESET_FILTERS_TEXT,
    NEWS_PAGE_SIZE,
    slugTermMapping,
    NEWS_NO_RESULTS_ERROR,
    NEWS_PATHNAME,
    NEWS_SEARCH_PLACEHOLDER,
    NEWS_BUTTON_TEXT,
    NEWS_BUTTON_TYPE,
};
